import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import Loader from '../loader/Loader'

import styles from './LeaderboardExport.module.scss'
import { ReactComponent as GolferIcon } from '../../../assets/images/common/communityLeaderboard/golfer-half-icon.svg'
import { ReactComponent as WarningIcon } from '../../../assets/images/common/icons/warning-icon.svg'

const LeaderboardExport = ({
  exportUrl,
  exportId,
  exportError,
  clearExport,
  onTryAgainButtonClick,
}) => {
  const { t } = useTranslation()

  return (
    <div className={classNames('d-flex flex-column justify-content-center align-items-center text-center', styles.communityLeaderboardExport)}>
      {exportUrl &&
        <>
          <GolferIcon />
          <p className={styles.exportTitle}>{t('common.leaderboardExport.exportedTitle')}</p>
          <p className={styles.exportText}>
            {t('common.leaderboardExport.exportedText')}
          </p>
          <a
            className={classNames('ml-3 w-30 mt-3 animation-shrink d-flex align-items-center justify-content-center', styles.downloadButton)}
            href={exportUrl}
            onClick={clearExport}
          >
            {t('common.leaderboardExport.downloadButton')}<i className='ml-2 fa fa-download' />
          </a>
        </>
      }
      {exportId &&
        <Loader>{t('common.leaderboardExport.exporting')}</Loader>
      }
      {exportError &&
        <>
          <WarningIcon className={styles.warningIcon} />
          <p className={styles.exportTitle}>{t('common.somethingWentWrong')}</p>
          <div className={styles.errorButtons}>
            <button
              className={classNames('ml-3 w-100 mt-3 animation-shrink', styles.tryAgain)}
              onClick={onTryAgainButtonClick}
            >
              {t('common.leaderboardExport.tryAgain')}
            </button>
            <button
              className={classNames('ml-3 w-100 mt-3 animation-shrink', styles.refresh)}
              onClick={clearExport}
            >
              {t('common.leaderboardExport.refresh')}
            </button>
          </div>
        </>
      }
    </div>
  )
}

LeaderboardExport.propTypes = {
  exportUrl: PropTypes.string,
  exportId: PropTypes.number,
  exportError: PropTypes.bool,
  clearExport: PropTypes.func,
  onTryAgainButtonClick: PropTypes.func,
}

export default LeaderboardExport
